import React from 'react'
// react plugin for creating charts
import { reportResponse } from '../../layouts/Aws.js'
import PropTypes from 'prop-types'
import LinearProgress from '@material-ui/core/LinearProgress'
import AtlasChart from '../../components/AtlasChart/AtlasChart.js'

export default function DailySales ({ reportPeriod }) {
  const [chartLoading, setChartLoading] = React.useState(true)
  const [salesChartData, setSalesChartData] = React.useState({})

  React.useEffect(() => {
    setChartLoading(true)
    updateData(reportPeriod.startDate, reportPeriod.endDate, reportPeriod.comparisonDate, reportPeriod.sites, reportPeriod.token)
  }, [reportPeriod])

  const updateData = (startDate, endDate, comparisonDate, sites, token) => {
    // get last 7 days by default
    reportResponse(startDate, endDate, comparisonDate, sites, 'daily', 'series', token).then(res => {
      if (res.error || res.errorType) {
        console.log(res)
      } else {
        // Initially the chart data set is empty
        const chartDataSet = []

        // The first data set that we want is the gross sales
        chartDataSet.push({
          label: 'Selected Period',
          data: res.grossSales[0],
          backgroundColor: '#1d2654',
          borderColor: '#1d2654',
          pointBackgroundColor: '#1d2654',
          fill: false
        })

        // The chart data to pass into AtlasChart
        var chartData = {
          labels: res.dates,
          dataSet: chartDataSet
        }

        // If there is a comparison date then
        // we add this to our data set
        if (comparisonDate) {
          if (chartData.dataSet.length === 1) {
            chartDataSet.push({
              label: 'Comparison Period',
              data: res.grossSales[1],
              backgroundColor: '#f05b4f55',
              borderColor: '#f05b4f55',
              pointBackgroundColor: '#f05b4f55',
              fill: false,
              borderDash: [5]
            })
          } else {
            chartDataSet[1].data = res.grossSales[1]
          }
        } else {
          if (chartData.dataSet.length === 2) {
            chartData.dataSet.pop()
          }

          // remove all comparison dates
          for (let i = 0; i < res.dates.length; i++) {
            res.dates[i][1] = ''
          }
        }

        setSalesChartData(chartData)
        setChartLoading(false)
      }
    })
  }

  return <div id="salesChartContainer">
    {chartLoading
      ? <div style={{ width: '100%', textAlign: 'center' }}>
        <LinearProgress />
      </div>
      : <AtlasChart
        chartId='dailySalesChart'
        chartType='line'
        data={salesChartData}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [{
              gridLines: {
                display: false
              }
            }],
            yAxes: [{
              gridLines: {
                display: false
              },
              ticks: {
                beginAtZero: true
              }
            }]
          }
        }
        }
        height='300'
      />
    }
  </div>
}

DailySales.propTypes = {
  reportPeriod: PropTypes.object
}
